import { render, staticRenderFns } from "./BnplTransactionDelay.vue?vue&type=template&id=6e4b9228&scoped=true&"
import script from "./BnplTransactionDelay.vue?vue&type=script&lang=js&"
export * from "./BnplTransactionDelay.vue?vue&type=script&lang=js&"
import style0 from "./BnplTransactionDelay.vue?vue&type=style&index=0&id=6e4b9228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4b9228",
  null
  
)

export default component.exports